import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";


import { FaFacebookF, FaInstagram, FaPinterestP } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import SearchByRoute from './components/SearchByRoute';
import BusTimetable from "./components/BusTimetable";

import Contact from "./components/contact";
import PrivacyPolicy from './components/policy';
import TermsConditions from './components/terms';
import ScrollToTop from "./components/ScrollToTop";

import './styles.css';
function App() {
  return (
    <Router>
      <ScrollToTop />

      <div className="container">
        {/* Header */}
        <header className="header">
         <div className="header-left">
  <Link to="/" className="brand-link">
    <img src="/sgkfinal.png" alt="Bus Logo" className="logo" />
    <h1 className="d-none d-lg-block mb-3">Evide Bus</h1>
  </Link>
</div>

          <nav className="header-right">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/#features">About Us</a></li>
              <li><a href="/contact">Contact Us</a></li>
              <li><a>Download</a></li>
            </ul>
          </nav>
        </header>

        {/* Page Content */}
        <main className="content">
          <Routes>
            <Route path="/" element={<SearchByRoute />} />
            <Route path="/bus-timetable" element={<BusTimetable />} />

            <Route path="/contact" element={<Contact />} />
            <Route path="/policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
          </Routes>
        </main>

        {/* Footer */}
        <div className="footer">
          <div className="footer-top">
            {/* Left Column */}
            <div className="footer-left">
              <img src="/sgkfinal.png" alt="Evide Bus Logo" className="footer-logo" />
              <p>
                Evide Bus helps passengers find reliable bus timings and routes quickly
                and easily.
              </p>
            </div>

            {/* Center Column */}
            <div className="footer-center">
              <h3>Usefull Links</h3>
              <ul>
                <li>
                  <a href="/#features">About Us</a>
                </li>
                <li><a href="/contact">Contact Us</a></li>
                <li><a href="/policy">Privacy Policy</a></li>
                <li><a href="/terms">Terms & Conditions</a></li>
              </ul>
            </div>

            {/* Right Column */}
            <div className="footer-right">
              <h6>Download</h6>
              <div className="store-badges">
                <img src="/playstore.png" alt="Google Play" />
                <img src="/appstore.svg" alt="App Store" />
              </div>
              <h6>Follow Us</h6>
              <div className="social-icons">
                <a><FaFacebookF /></a>
                <a><FaInstagram /></a>
                <a><FaPinterestP /></a>
                <a><FaXTwitter /></a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="footer-bottom">
            <p>© 2026 Evide Bus. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;

